var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSafeRental = function SvgSafeRental(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 58"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#safe-rental_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.498 9.677h-1.603l1.1 1.1 6.155 6.815 6.596.66 2.638 1.099c0-.88.018-1.973-.22-2.858-.22-1.32-.879-1.1-2.418-1.1-5.45 0-9.809-3.64-11.612-5.449a.9.9 0 0 0-.636-.267"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#safe-rental_svg__b)",
    fillOpacity: 0.4,
    d: "M29.498 9.677h-1.603l1.1 1.1 6.155 6.815 6.596.66 2.638 1.099c0-.88.018-1.973-.22-2.858-.22-1.32-.879-1.1-2.418-1.1-5.45 0-9.809-3.64-11.612-5.449a.9.9 0 0 0-.636-.267"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M40.647 40.897c5.369-5.652 4.644-18.747 3.573-24.76a.73.73 0 0 0-.317-.478 1.12 1.12 0 0 0-.865-.162l-1.512.336 1.54 2.199-2.64 17.808-12.311 12.752c.44-.04 2.434.03 2.858-.22 3.738-2.198 5.496-3.078 9.674-7.475"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#safe-rental_svg__c)",
    fillOpacity: 0.4,
    d: "M40.647 40.897c5.369-5.652 4.644-18.747 3.573-24.76a.73.73 0 0 0-.317-.478 1.12 1.12 0 0 0-.865-.162l-1.512.336 1.54 2.199-2.64 17.808-12.311 12.752c.44-.04 2.434.03 2.858-.22 3.738-2.198 5.496-3.078 9.674-7.475"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.66,
    d: "M27.895 10.018c1.132 1.235 3 3.052 5.325 4.42 2.445 1.44 5.428 2.402 8.593 1.624.394-.096.757.16.79.5.295 3.138.498 7.393.221 11.474-.277 4.096-1.034 7.957-2.614 10.356-3.333 5.061-9.47 8.591-12.315 9.812-2.846-1.221-8.982-4.751-12.315-9.812-1.58-2.399-2.337-6.26-2.614-10.356-.277-4.081-.074-8.336.221-11.475.033-.34.396-.595.79-.499 3.165.778 6.148-.185 8.593-1.624 2.324-1.368 4.192-3.185 5.325-4.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    fillOpacity: 0.67,
    d: "M27.89 48.569q-.006-.002-.013 0l-.017.007a.026.026 0 0 1-.037-.024q0-.017-.016-.024c-2.85-1.213-9.1-4.79-12.501-9.955-3.26-4.95-3.04-15.744-2.447-22.042.054-.572.64-.926 1.197-.79 6.098 1.499 11.563-3.687 13.761-6.13a.03.03 0 0 0 .008-.014l.007-.03c.003-.014.026-.032.039-.041a.1.1 0 0 1 .02-.006z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.32 25.459a.88.88 0 0 1 .313-.672l7.695-6.496a.88.88 0 0 1 1.134 0l7.695 6.496a.88.88 0 0 1 .312.672V35.84a.88.88 0 0 1-.88.88H20.2a.88.88 0 0 1-.879-.88z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#895FFC",
    d: "M19.32 25.459a.88.88 0 0 1 .313-.672l7.695-6.496a.88.88 0 0 1 1.134 0l7.695 6.496a.88.88 0 0 1 .312.672V35.84a.88.88 0 0 1-.88.88H20.2a.88.88 0 0 1-.879-.88z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#safe-rental_svg__d)",
    fillOpacity: 0.6,
    d: "M19.32 25.459a.88.88 0 0 1 .313-.672l7.695-6.496a.88.88 0 0 1 1.134 0l7.695 6.496a.88.88 0 0 1 .312.672V35.84a.88.88 0 0 1-.88.88H20.2a.88.88 0 0 1-.879-.88z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.446,
    d: "m23.88 28.844 2.474 2.893 4.756-5.062"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "safe-rental_svg__b",
    x1: 47.705,
    x2: 21.344,
    y1: 14.514,
    y2: -7.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "safe-rental_svg__c",
    x1: 47.801,
    x2: 31.56,
    y1: 32.323,
    y2: 15.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "safe-rental_svg__d",
    x1: 27.895,
    x2: 27.895,
    y1: 17.812,
    y2: 36.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "safe-rental_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h58v58H0z"
  })))));
};
export default SvgSafeRental;